<app-generic-table-header
	[config]="headerOptions"
	(selectAllPressed)="selectAll($event)"
	(exportPressed)="exportReport($event)"
	(refreshEvent)="refresh($event)">
</app-generic-table-header>
<ng-template
	#prefixTemplate
	let-row>
	<app-card-table-actions
		[row]="row"
		(actionEvent)="selectRow($event)"
		[breakpoint]="ScreenSize.TABLET"
		>
	</app-card-table-actions>
</ng-template>
@if (keepAliveData != null && keepAliveData.length > 0 && !loadingKADevices) {
<app-card-table
	#KATable
	[tableHeaders]="keepAliveTableHeaders"
	[currentPage]="kaCurrentPage"

	[data]="keepAliveData"
	[totalItems]="totalKeepAliveDevices"
	[options]="keepAliveTableOptions"
	[enableInfiteScroll]="false"
	[enableTablePagination]="true"
	[prefixTemplate]="prefixTemplate"
	(paginateEvent)="getPagedDevices($event)"
	[breakpoint]="ScreenSize.TABLET"
	[enableRefresher]="false"
	(dataRefreshedEvent)="refreshData($event)"
	[allSelected]="allSelected"
	(rowSelectedEvent)="selectRow($event)">
</app-card-table>
}
@if (loadingKADevices) {
<div>
	<mat-spinner
		class="spinner"
		name="crescent"></mat-spinner>
</div>
}
@if (!loadingKADevices && (keepAliveData == null || keepAliveData.length < 1)) {
<div

	class="centered">
	No Devices found
</div>
}
